import styled from "styled-components";

//STYLES
const Line = styled.div`
    width: 100%;
    height: 1px;
    min-height: 1px;
    background-color: var(--border-color);
`;

//PROPS
interface Props {
    size?: number;
    marginTop?: number;
}

export const LineDivider: React.FC<Props> = ({ size, marginTop }) => {
    return (
        <Line style={{height: size, marginTop: marginTop}} />
    )
}